var _classCallCheck = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/qw/WebstormProjects/jwc/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var request = require('./request');

var storage = require('./storage');

var query = require('./query');

var Bmob = require('./bmob');

var Error = require('./error');

var _require = require('./dataType'),
    isObject = _require.isObject,
    isString = _require.isString,
    isNumber = _require.isNumber;

var user =
/*#__PURE__*/
function (_query) {
  "use strict";

  _inherits(user, _query);

  function user() {
    _classCallCheck(this, user);

    var tableName = '_User';
    return _possibleConstructorReturn(this, _getPrototypeOf(user).call(this, tableName));
  }

  _createClass(user, [{
    key: "set",
    value: function set(key) {
      var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (isString(key)) {
        this.setData[key] = val;
      }
    }
  }, {
    key: "requestEmailVerify",
    value: function requestEmailVerify(email) {
      if (!isString(email)) {
        // 异常
        throw new Error(415);
      }

      this.setData = Object.assign({}, {
        email: email
      });
      console.log(this.setData);
      var route = Bmob._config.parameters.REQUEST_EMAIL_VERIFY;
      return request(route, 'post', this.setData);
    }
  }, {
    key: "register",
    value: function register(parma) {
      if (!isObject(parma)) {
        // 异常
        throw new Error(415);
      }

      this.setData = Object.assign({}, parma);
      var route = Bmob._config.parameters.REGISTER;
      return request(route, 'post', this.setData);
    }
  }, {
    key: "login",
    value: function login(username, password) {
      var _this = this;

      if (!isString(username) || !isString(password)) {
        // 异常
        throw new Error(415);
      }

      this.setData = Object.assign({}, {
        username: username,
        password: password
      });
      var route = Bmob._config.parameters.LOGIN;
      return new Promise(function (resolve, reject) {
        request(route, 'get', _this.setData).then(function (res) {
          storage.save('bmob', res);
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      storage.clear();
    }
  }, {
    key: "users",
    value: function users() {
      var route = Bmob._config.parameters.USERS;
      return request(route, 'get');
    }
  }, {
    key: "decryption",
    value: function decryption(e) {
      var self = this;
      return new Promise(function (resolve, reject) {
        var i = e.iv ? e.iv : e.detail.iv;
        var d = e.encryptedData ? e.encryptedData : e.detail.encryptedData; // 调用云函数解密

        var current = self.current();
        var s;

        if (typeof tt !== 'undefined') {
          s = current.authData.toutiao.session_key;
        } else {
          s = current.authData.weapp.session_key;
        }

        var data = {
          'sessionKey': s,
          'encryptedData': d,
          'iv': i
        };
        var route = Bmob._config.parameters.DECRYPTION;
        request(route, 'POST', data).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "signOrLoginByMobilePhone",
    value: function signOrLoginByMobilePhone(mobilePhoneNumber, smsCode) {
      // 手机号登陆
      if (!isNumber(mobilePhoneNumber) || !isNumber(smsCode)) {
        // 异常
        throw new Error(415);
      }

      this.setData = Object.assign({}, {
        mobilePhoneNumber: mobilePhoneNumber,
        smsCode: smsCode
      });
      var route = Bmob._config.parameters.LOGIN;
      return request(route, 'get', this.setData);
    }
  }, {
    key: "requestOpenId",
    value: function requestOpenId(code) {
      var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var route = Bmob._config.parameters.WECHAT_APP;
      return request(route + code, 'POST', {
        'anonymous_code': a
      });
    }
  }, {
    key: "linkWith",
    value: function linkWith(data) {
      // 第三方登陆
      var authData = {
        'authData': data
      };
      var route = Bmob._config.parameters.USERS;
      return request(route, 'POST', authData);
    }
  }, {
    key: "loginWithWeapp",
    value: function loginWithWeapp(code) {
      var _this2 = this;

      var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return new Promise(function (resolve, reject) {
        _this2.requestOpenId(code, a).then(function (res) {
          var w = {
            'weapp': res
          };

          if (typeof tt !== 'undefined') {
            delete res.error;
            w = {
              'toutiao': res
            };
          }

          var result = _this2.linkWith(w);

          resolve(result);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: "upInfo",
    value: function upInfo(userInfo) {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        var nickName = userInfo.nickName;
        var avatarUrl = userInfo.avatarUrl;

        var currentUser = _this3.current();

        if (!currentUser) {
          throw new Error(415);
        }

        var openid = storage.fetch('openid');

        _this3.get(currentUser.objectId).then(function (res) {
          res.set('nickName', nickName);
          res.set('userPic', avatarUrl);
          res.set('openid', openid);
          res.save().then(function (result) {
            resolve(result);
          }).catch(function (err) {
            console.log(err);
            reject(err);
          });
        }).catch(function (err) {
          console.log(err);
          reject(err);
        });
      });
    }
  }, {
    key: "auth",
    value: function auth() {
      var that = this;
      return new Promise(function (resolve, reject) {
        var login = function login() {
          wx.login({
            success: function success(res) {
              console.log(res);
              var anonymousCode = '';

              if (typeof tt !== 'undefined') {
                anonymousCode = res.anonymousCode;
              }

              that.loginWithWeapp(res.code, anonymousCode).then(function (user) {
                if (user.error) {
                  throw new Error(415);
                }

                var openid;

                if (typeof tt !== 'undefined') {
                  openid = user.authData.toutiao.openid;
                } else {
                  openid = user.authData.weapp.openid;
                }

                storage.save('openid', openid);
                storage.save('bmob', user); // 保存用户其他信息到用户表

                resolve(user);
              }, function (err) {
                reject(err);
              });
            }
          });
        };

        wx.checkSession({
          success: function success() {
            var c = that.current();

            if (c === null) {
              var e = '登陆错误，请在Bmob后台填写小程序AppSecret。';
              reject(e);
            }

            resolve(c);
            login();
          },
          fail: function fail() {
            login();
          }
        });
      });
    }
  }]);

  return user;
}(query);

module.exports = user;